import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { Divider, Stack, Box, Typography } from '@mui/material'
import FormInput from './FormInput'
import localization from '../utils/localization'
import ExtraForm from './ExtraForm'
import ContentUtils from '../utils/content'

const TextForm = forwardRef((props, ref) => {
  const [title, setTitle] = useState(props.contentInfo.id ? props.contentInfo.title : '')
  const [titleErr, setTitleErr] = useState('')
  const [text, setText] = useState(props.contentInfo.id ? props.contentInfo.content : '')
  const [textErr, setTextErr] = useState('')
  const [extra, setExtra] = useState(props.contentInfo.id ? props.contentInfo.extra : {})

  useEffect(() => {
    if (props.contentInfo.id) {
      setTitle(props.contentInfo.title)
      setTitleErr('')
      setText(props.contentInfo.content)
      setTextErr('')
      setExtra(props.contentInfo.extra)
    }
  }, [props.contentInfo])

  useImperativeHandle(ref, () => ({
    checkForm() {
      let hasErr = false
      if (title === '') {
        setTitleErr(localization.strings.required)
        hasErr = true
      }
      if (text === '') {
        setTextErr(localization.strings.required)
        hasErr = true
      }
      return hasErr
    },
    getContentData() {
      return {
        title: title,
        content: text,
        type: ContentUtils.getTextType(),
        color: 'blue',
        account: '',
        extra: extra,
      }
    },
  }))

  return (
    <Stack spacing={3}>
      <Box>
        <FormInput
          label={localization.strings.title}
          value={title}
          placeholder={localization.strings.inputTitleHint}
          error={titleErr}
          onChange={(event) => {
            setTitle(event.target.value)
            setTitleErr('')
          }}
        />
      </Box>

      <Box>
        <FormInput
          multiline={true}
          rows={6}
          label={localization.strings.text}
          value={text}
          error={textErr}
          placeholder={localization.strings.inputTextHint}
          onChange={(event) => {
            setText(event.target.value)
            setTextErr('')
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '16px',
              backgroundColor: 'rgba(0,0,0,0.02)',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
            },
          }}
        />
      </Box>

      <Divider sx={{ opacity: 0.5 }} />

      <Box>
        <ExtraForm extra={extra} onChange={(e) => setExtra(e)} />
      </Box>
    </Stack>
  )
})

export default TextForm
